import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Sun, Moon, ArrowRight } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import './Navbar.css';

const navLinks = [
  { label: 'Home',      path: '/' },
  { label: 'About',     path: '/about' },
  { label: 'Services',  path: '/products' },
  { label: 'Careers',   path: '/careers' },
  { label: 'Solutions', path: '/solutions' },
  { label: 'Clients',   path: '/clients' },
  { label: 'Contact',   path: '/contact' },
];

function ThemeToggle({ compact }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      className={`theme-toggle ${compact ? 'compact' : ''}`}
      onClick={toggle}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {isDark ? <Sun size={14} color="#C9A84C" /> : <Moon size={14} color="#8B0000" />}
      <div className={`toggle-track ${isDark ? 'on' : ''}`}>
        <div className={`toggle-thumb ${isDark ? 'on' : ''}`} />
      </div>
    </button>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  return (
    <>
      <header className={`navbar-wrap ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-pill">
          {/* Logo */}
          <Link to="/" className="navbar-logo">
            <img src='/assets/logo/logo-removebg-preview.png' style={{height:"7vh"}} />

            {/* <div className="navbar-logo-mark">
              <span className="logo-mark-inner">RC</span>
            </div>
            <div className="navbar-logo-text">
              <span className="logo-main">SHIVKMS</span>
              <span className="logo-sub">Multi Solution</span>
            </div> */}
          </Link>

          {/* Desktop center nav */}
          <nav className="navbar-links">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right cluster */}
          <div className="navbar-cta">
            <ThemeToggle compact />
            {/* <Link to="/contact" className="navbar-login">Login</Link> */}
            <Link to="/contact" className="btn-primary nav-btn">
              Get Started
            </Link>
            <button
              className="mobile-menu-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              {menuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <nav className="mobile-menu-links">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mobile-menu-footer">
            <ThemeToggle />
            <Link to="/contact" className="btn-primary" style={{ flex: 1, justifyContent: 'center' }}>
              Get Started <ArrowRight size={16} />
            </Link>
          </div>
        </nav>
      </div>
      {menuOpen && <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)} />}
    </>
  );
}
